import { Container } from '@mui/material'
import React from 'react'
import { BooleanInput, Datagrid, List, TextField, TextInput, useTranslate } from 'react-admin'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { hasPermissionFunction } from 'src/helper/HasPermission'

export const SourcePaymentList = (props) => {
    const translate = useTranslate()

    const sourceFilters = [
        <TextInput label={translate('ra.field.id')} source='id' defaultValue='' />,
        <TextInput label={translate('ra.field.short_name')} source='short_name' defaultValue='' />,
        <TextInput label={translate('ra.field.long_name')} source='long_name' defaultValue='' />,
        <BooleanInput label={translate('ra.field.is_active')} source='is_active' defaultValue={true} />,
      ]
  return (
    <Container className='content'>
      <CardCommon title={''}>
        <List
          {...props}
          component='div'
          filters={sourceFilters}
          /* actions={<ListViewTopToolbar hasCreate={permissions?.hasCreate} />} */
        >
          <Datagrid rowClick='show' /* setSort={onClickSort} isLoading={isLoading} */>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='short_name' label={translate('ra.field.short_name')} />
            <TextField source='long_name' label={translate('ra.field.long_name')} />
            {hasPermissionFunction('sourcePayment', 'edit') && (
                <ListViewActionsButtons
                label={translate('ra.action.actions')}
                fieldsName={['short_name']}
                genderElement='femenine'
                disableRevision
                />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
